/// <amd-module name="Search/WorkItem/Components/LeftPane/MetadataSection" />
import * as React from "react";
import { Icon } from "VSSUI/Icon";
import { css } from "VSSUI/Util";
import { Pill, PillSize } from "VSSUI/Pill";
import { PillGroup, PillGroupOverflow } from "VSSUI/PillGroup";
import { WrappedComponent } from "VSS/Platform/Layout";
import { Ref } from "Search/WorkItem/Constants";
import * as Resources from "Search/WorkItem/Resources";
import { IHighlightFragment } from "Search/WorkItem/Flux/Stores/SnippetFragmentCache";

export interface IMetadataSectionProps {
    fields: { [id: string]: string };

    project: string;

    aggregatedHits: { [key: string]: IHighlightFragment };
}

export const MetadataSection = (props: IMetadataSectionProps) => {
    const { aggregatedHits, fields, project } = props;
    // state
    const workItemType = fields[Ref.type];
    const state = aggregatedHits[Ref.state] ? aggregatedHits[Ref.state].highlights[0] : fields[Ref.state];

    // avatar name and image    
    const assignedTo = aggregatedHits[Ref.assignedTo] ? aggregatedHits[Ref.assignedTo].highlights[0] : fields[Ref.assignedTo] || "";
    const isAliasHit = !!aggregatedHits[Ref.assignedTo];

    let avatar = removeAlias(assignedTo);
    avatar = avatar === "" ? Resources.Unassigned : avatar;

    const highlightNeeded = isAliasHit && avatar !== Resources.Unassigned;
    let tagsList = fields[Ref.tags] ? fields[Ref.tags].split(/[;,]/) : [];

    return (
        <div className="workitem-metadata flex-row flex-center">
            <div className="flex-row flex-center flex-noshrink">
                <Icon className="avatar-image" iconName="Contact" />
                <div className={css("avatar-name flex-grow text-ellipsis", highlightNeeded && "fontWeightBold")} dangerouslySetInnerHTML={{ __html: avatar }} />
            </div>
            <div className="flex-row flex-center flex-noshrink">
                <WrappedComponent
                    dependencies={["ms.vss-search-web.workitem-type-icon-content"]}
                    wrappedType="workItemStateCircle"
                    wrappedProps={{
                        projectId: project,
                        workItemType: workItemType,
                        workItemState: state,
                    }} />
                <span className="state-text flex-grow text-ellipsis" dangerouslySetInnerHTML={{ __html: state }} />
            </div>
            {
                tagsList.length ? (
                    <PillGroup overflow={PillGroupOverflow.clip}>
                        {
                            tagsList.map((tag, idx) => <Pill excludeFocusZone={true} excludeTabStop={true} key={`tag${idx}`} size={PillSize.compact}>{tag}</Pill>)
                        }
                    </PillGroup>
                ) : null
            }
        </div>
    );
}

function removeAlias(avatarName: string): string {
    avatarName = avatarName.trim();

    const lengthOfString = avatarName.length;
    let unpairedClosedBrackets = avatarName[lengthOfString - 1] === ">" ? 1 : 0;
    let i = lengthOfString - 2;

    // Return if the string is empty or if there is no '>' character at the end of string.
    if (lengthOfString === 0 || unpairedClosedBrackets === 0) {
        return avatarName;
    }

    // Scan backwards until the matching open bracket for the '>' (at the end of string) is found.
    for (; unpairedClosedBrackets > 0 && i >= 0; i--) {
        avatarName[i] === ">" ? unpairedClosedBrackets++ : (avatarName[i] === "<" && unpairedClosedBrackets--);
    }

    return avatarName.substring(0, i + 1).trim();
}
